import React from 'react'
import { Link, withRouter } from 'react-router-dom'

const ListingListActionPanel = ({ match }) => (
  <div className="has-text-right">
    <Link className="button is-primary" to={match.url + "/create"}>
      <span className="icon">
        <i className="fas fa-plus" aria-hidden="true" />
      </span>
      <span>
        <strong> Create </strong>
      </span>
    </Link>
  </div>
)

export default withRouter(ListingListActionPanel)



// WEBPACK FOOTER //
// ./src/components/templates/listing-list/ListingListActionPanel.js